import { createSlice } from "@reduxjs/toolkit";
import {
  getNotificationsInfoService,
  getNotificationsService,
  getStatisticsService,
  getAllContactUSerService,
  getDiscountCouponsService,
  createDiscountCodeService,
  getAdvertisementsService,
  getStoreInfoService,
  getAllgovernoratesService,
  getAreaByGovService,
  getShippingByIdService,
  getShippingService,
  getCarBrandsService,
  getgearTypeService,
  getFuelTypesService,
  getColorsService,
  getCarTypesService,
  getFavoriteListingsService,
  getFavoriteListingDetailService,
  createFavoriteListingService,
  deleteFavoriteListingService,
  getCarModelsService,
  getImportingCountriesService
} from "../services/general_service";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  permissions: [],
  notifications: [],
  metaNotifications: null,
  statistics: {},
  contactUserList: [],
  metaContactUser: null,
  discountCode: [],
  metaDiscountCode: null,
  advertisment: [],
  metaAdvertismentCode: null,
  storeInfo: null,
  generalNotifications: [],
  metaGeneralNotifications: null,
  governoratesList: [],
  areas: [],
  shippingOfArea: {},
  shippingList: [],
  vehiclesList: [],
  metVehicles: null,
  gearTypeList: [],
  metGearType: null,
  fuelTypeList: [],
  metFuelType: null,
  colorsList: [],
  metaColors: null,
  carTypesList: [],
  metaCarType: null,
  carModelsList: [],
  metaCarModels: null,
  importingCountriesList: [],
  metaImportingList: null,
};

const slice = createSlice({
  name: "permissions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Using builder callback notation
    builder
      .addCase(getNotificationsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.notifications = action.payload?.data?.data;
        state.metaNotifications = action.payload.data.meta.meta;
      })
      .addCase(getNotificationsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getNotificationsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getStatisticsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.statistics = action.payload?.data?.data;
      })
      .addCase(getStatisticsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getStatisticsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getAllContactUSerService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.contactUserList = action.payload?.data?.data;
        state.metaContactUser = action.payload.data.meta.meta;
      })
      .addCase(getAllContactUSerService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getAllContactUSerService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getDiscountCouponsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.discountCode = action.payload?.data?.data;
        state.metaDiscountCode = action.payload.data.meta.meta;
      })
      .addCase(getDiscountCouponsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getDiscountCouponsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getAdvertisementsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.advertisment = action.payload?.data?.data;
        state.metaAdvertismentCode = action.payload.data?.meta?.meta;
      })
      .addCase(getAdvertisementsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getAdvertisementsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getStoreInfoService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.storeInfo = action.payload?.data?.data;
      })
      .addCase(getStoreInfoService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getStoreInfoService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getNotificationsInfoService.fulfilled, (state, action) => {
        console.log(action.payload?.data?.data);
        state.isLoading = false;
        state.generalNotifications = action.payload?.data?.data;
        state.metaGeneralNotifications = action.payload.data.meta.meta;
      })
      .addCase(getNotificationsInfoService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getNotificationsInfoService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getAllgovernoratesService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.governoratesList = action.payload?.data?.data;
        //   state.metaContactUser = action.payload.data.meta.meta;
      })
      .addCase(getAllgovernoratesService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getAllgovernoratesService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })

      .addCase(getAreaByGovService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.areas = action.payload?.data?.data;
        //   state.metaContactUser = action.payload.data.meta.meta;
      })
      .addCase(getAreaByGovService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getAreaByGovService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getShippingByIdService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.shippingOfArea = action.payload?.data?.data;
        //   state.metaContactUser = action.payload.data.meta.meta;
      })
      .addCase(getShippingByIdService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getShippingByIdService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getCarBrandsService.fulfilled, (state, action) => {
        console.log(action.payload?.data?.data);
        state.isLoading = false;
        state.vehiclesList = action.payload?.data?.data;
        state.metVehicles = action.payload?.data?.meta?.meta;
      })
      .addCase(getCarBrandsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getCarBrandsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getgearTypeService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.gearTypeList = action.payload?.data?.data;
        state.metGearType = action.payload?.data?.meta?.meta;
      })
      .addCase(getgearTypeService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getgearTypeService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getFuelTypesService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.fuelTypeList = action.payload?.data?.data;
        state.metFuelType = action.payload?.data?.meta?.meta;
      })
      .addCase(getFuelTypesService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getFuelTypesService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getColorsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.colorsList = action.payload?.data?.data;
        state.metaColors = action.payload?.data?.meta?.meta;
      })
      .addCase(getColorsService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getColorsService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getCarTypesService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.carTypesList = action.payload?.data?.data;
        state.metaCarType = action.payload?.data?.meta?.meta;
      })
      .addCase(getCarTypesService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getCarTypesService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      })
      .addCase(getFavoriteListingsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.favoriteListings = action.payload?.data?.data;
        state.metaFavoriteListings = action.payload?.data?.meta?.meta;
      })
      .addCase(getFavoriteListingsService.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getFavoriteListingsService.pending, (state) => {
        state.isLoading = true;
      })

      // GET => Favorite Listing Detail
      .addCase(getFavoriteListingDetailService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.favoriteListingDetail = action.payload?.data?.data;
      })
      .addCase(getFavoriteListingDetailService.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getFavoriteListingDetailService.pending, (state) => {
        state.isLoading = true;
      })

      // POST => Create Favorite Listing
      .addCase(createFavoriteListingService.fulfilled, (state, action) => {
        state.isLoading = false;
        // نضيف المفضلة الجديدة لقائمة المفضلات الحالية
        state.favoriteListings = [
          action.payload?.data?.data,
          ...(state.favoriteListings || []),
        ];
      })
      .addCase(createFavoriteListingService.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(createFavoriteListingService.pending, (state) => {
        state.isLoading = true;
      })

      // DELETE => Delete Favorite Listing
      .addCase(deleteFavoriteListingService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.favoriteListings = state.favoriteListings?.filter(
          (item) => item.id !== action.meta.arg,
        );
      })
      .addCase(deleteFavoriteListingService.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteFavoriteListingService.pending, (state) => {
        state.isLoading = true;
      }) // GET => CAR MODELS
      .addCase(getCarModelsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.carModelsList = action.payload?.data?.data;
        state.metaCarModels = action.payload?.data?.meta?.meta;
      })
      .addCase(getCarModelsService.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getCarModelsService.pending, (state) => {
        state.isLoading = true;
      }).addCase(getImportingCountriesService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.importingCountriesList = action.payload?.data?.data;
        state.metaImportingList = action.payload?.data?.meta?.meta;
      })
      .addCase(getImportingCountriesService.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getImportingCountriesService.pending, (state) => {
        state.isLoading = true;
      });
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const { } = slice.actions;
